import { theme } from "aaa";
import { ui } from "components/util/uiHelpers";
import * as i18n from "i18n/util";
import { themeColors } from "muiTheme";
import * as React from "react";

type CancelButtonProps = {
    onClick: () => void;
    messageId?: i18n.IDS;
    color?: string;
};

export const CancelButton = ({
    onClick,
    messageId = "gJunior.activation.download.close",
    color = themeColors.georgeBlue,
}: CancelButtonProps) => {
    return (
        <div style={{
            position: "fixed",
            maxWidth: theme.MAX_APP_WIDTH,
            width: "100%",
            bottom: theme.MARGIN_LARGE,
            marginLeft: "auto",
            marginRight: "auto",
        }}>
            <div
                role="button"
                onClick={onClick}
                style={{
                    backgroundColor: "transparent",
                    color: ui.isDarkMode ? "white" : color,
                    fontSize: 18,
                    fontWeight: 600,
                    textAlign: "center",
                    cursor: "pointer",
                }}
            >
                {ui.__(messageId)}
            </div>

        </div>

    );
};



// WEBPACK FOOTER //
// ./src/components/gJunior/components/CancelButton.tsx